import { date as formatWallDate, time as formatWallTime } from '@/plugins/dates'

/**
 * Describe the booked event or transaction an activity stream row belongs to.
 *
 * Booking activity rows (source 2) carry event_name, event_date (DATE) and event_start_time
 * (TIME). Both are venue wall clock straight from booking_slots, so they are formatted as-is
 * with the group's formats and never routed through the UTC-shifting group helpers that
 * format the row's own timestamp. Booking rows also carry booking_slot_id, which opens the
 * slot in the Bookings drawer (/bookings?selected_booking=). Transaction activity rows
 * (source 3) carry order_number.
 *
 * Returns { label, when, transactionId, bookingSlotId } with empty strings where the row has nothing.
 */
export function describeActivityEvent(row, group) {
  const g = group || {}
  const dateFormat = g.date_format || 'MM/DD/YYYY'
  const timeFormat = g.time_format || 'hh:mm'
  const transactionId = row && row.transaction_id != null && row.transaction_id !== '' ? Number(row.transaction_id) : null
  const bookingSlotId = row && row.booking_slot_id != null && row.booking_slot_id !== '' ? Number(row.booking_slot_id) : null

  if (row && row.event_name) {
    const datePart = row.event_date ? formatWallDate(String(row.event_date).slice(0, 10), dateFormat) : ''
    const timePart = row.event_start_time ? formatWallTime(row.event_start_time, timeFormat) : ''
    return {
      label: row.event_name,
      when: [datePart, timePart].filter(Boolean).join(', '),
      transactionId,
      bookingSlotId
    }
  }

  if (row && row.order_number) {
    return { label: String(row.order_number), when: '', transactionId, bookingSlotId: null }
  }

  return { label: '', when: '', transactionId, bookingSlotId: null }
}
